module.exports = __webpack_public_path__ + "img/long-light-monchrome.0e42b6a.svg";